import React from 'react';
import LegalLayout from '../components/LegalLayout';

const CancellationRefund = () => {
  return (
    <LegalLayout title="Cancellation & Refund Policy">
      <p>
        Intlrr follows a transparent and fair cancellation and refund policy.
      </p>

      <h3>1. Program Cancellation</h3>
      <p>
        Once a program has started or access to recordings/materials is provided, cancellations are not permitted.
      </p>

      <h3>2. Refund Eligibility</h3>
      <p>
        Refunds are applicable only if requested before the program start date and within the communicated refund window.
      </p>

      <h3>3. Non-Refundable Items</h3>
      <p>
        Mentorship sessions, live workshops, certificates, and recorded content are non-refundable.
      </p>

      <h3>4. Refund Processing</h3>
      <p>
        Approved refunds will be processed within 7–10 working days to the original payment method.
      </p>

      <h3>5. Contact</h3>
      <p>
        For refund queries, write to <strong>support@intlrr.com</strong>.
      </p>
    </LegalLayout>
  );
};

export default CancellationRefund;
